import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { access } from './schemas/common.js';
import { activityCursorSchema, activityItemSchema, activityTypeSchema, } from './schemas/activity.js';
const c = initContract();
export const activityContract = c.router({
    list: {
        method: 'GET',
        metadata: access('viewer'),
        path: '/activity',
        summary: 'Replies, retrievals, blocked senders and errors, newest first',
        query: z.object({
            type: activityTypeSchema.optional(),
            /** `nextBefore` from the previous page. */
            before: activityCursorSchema.optional(),
            limit: z.coerce.number().int().min(1).max(100).default(50),
            /** 1-based. Numbered paging with a `total`; `before` is ignored when set. */
            page: z.coerce.number().int().min(1).max(100_000).optional(),
        }),
        responses: {
            200: z.object({
                items: z.array(activityItemSchema),
                /** Absent on the last page. */
                nextBefore: activityCursorSchema.optional(),
                /** Rows matching the filter, when a `page` was asked for. */
                total: z.number().int().optional(),
            }),
        },
    },
});
//# sourceMappingURL=activity.contract.js.map